import { CLICK_ID_COOKIE_KEYS } from './getUtmCookies';

const NINETY_DAYS_MS = 90 * 24 * 60 * 60 * 1000;

export function captureClickIdsFromUrl() {
  if (typeof window === 'undefined') return;

  const params = new URLSearchParams(window.location.search);
  const shouldShareAcrossSubdomains =
    process.env.NODE_ENV === 'production' && window.location.hostname.endsWith('alitu.com');
  const paramToCookie = {
    gclid: CLICK_ID_COOKIE_KEYS.GCLID,
    gbraid: CLICK_ID_COOKIE_KEYS.GBRAID,
    wbraid: CLICK_ID_COOKIE_KEYS.WBRAID,
  };

  Object.entries(paramToCookie).forEach(([param, cookieName]) => {
    const value = params.get(param);
    if (!value) return;

    const expires = new Date(Date.now() + NINETY_DAYS_MS).toUTCString();
    const secure = window.location.protocol === 'https:';
    const domain = shouldShareAcrossSubdomains ? '; domain=.alitu.com' : '';

    document.cookie = `${cookieName}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax${secure ? '; Secure' : ''}${domain}`;
  });
}
